<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    destroy-on-close
    top="30vh"
    width="30%"
  >
    <div class="list">
      <div class="title">是否{{ text }}当前信息审核</div>
      <div class="more" v-if="!isAudit">
        <div class="label">备注</div>
        <el-input v-model="remark"></el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer" v-if="!isAudit">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button :type="type==1?'primary':'danger'" @click="$handle()" v-text="type==1?'通过':'拒绝'"></el-button>
    </span>
  </el-dialog>
</template>
<script>
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";

export default {
  data() {
    return {
      dialogVisible: false,
      answer_info: null,
      remark: "",
      id: "",
      text: "",
      type: 1, //1、通过 2、拒绝
      isAudit: false, //是否已审批,
      title: ""
    };
  },
  methods: {
    show(msg) {
      this.remark = "";
      this.dialogVisible = true;
      this.id = msg.arr;
      this.type = msg.type;
      if (msg.type == 1) {
        this.text = "通过";
        this.title = "通过审批";
      } else {
        this.text = "拒绝通过";
        this.title = "拒绝通过";
      }
    },
    $handle() {
      if (this.type == 1) {
        this.$api
          .allowAnswer({
            token: localStorage.getItem("token"),
            ids: JSON.stringify(this.id),
            remark: this.remark
          })
          .then(({ data }) => {
            this.dialogVisible = false;
            this.$root.$emit("refresh_list", "审核通过成功");
          })
          .catch(({ error }) => {});
      } else {
        this.$api
          .notAllowAnswer({
            token: localStorage.getItem("token"),
            ids: JSON.stringify(this.id),
            remark: this.remark
          })
          .then(({ data }) => {
            this.dialogVisible = false;
            this.$root.$emit("refresh_list", "审核拒绝成功");
          })
          .catch(({ error }) => {});
      }
    }
  },
  created() {
    this.$root.$on("showSurveyAudit", (msg) => {
      this.show(msg);
    });
  },
  beforeDestroy() {
    this.$root.$off("showAnswerInfo");
  }
};
</script>
<style scoped>
.list .item {
  display: flex;
  margin-bottom: 16px;
}
.list .item .label {
  text-align: right;
  min-width: 70px;
  color: #bfbfbf;
  margin-right: 16px;
}
.list {
  max-height: 60vh !important;
  margin-right: 5px;
}
.list .more {
  display: flex;
  align-items: center;
}
.more .label {
  min-width: 30px;
  text-align: left;
  margin-right: 16px;
}
.title {
  margin-bottom: 30px;
  color: #333;
}
</style>


<style>
.survey-info div::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  /**/
}
.survey-info div::-webkit-scrollbar-track {
  background: rgb(255, 255, 255);
  border-radius: 2px;
}
.survey-info div::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
.survey-info div::-webkit-scrollbar-thumb:hover {
  background: rgb(156, 156, 156);
}
.survey-info div::-webkit-scrollbar-corner {
  background: #efefef;
}
</style>


// WEBPACK FOOTER //
// src/components/survey/audit.vue